import { render } from "./OpenResponseQuestion.vue?vue&type=template&id=aefac282"
import script from "./OpenResponseQuestion.vue?vue&type=script&lang=js"
export * from "./OpenResponseQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__